var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4744 3.90625C19.0573 3.90722 18.6445 3.98733 18.2599 4.14196C17.8752 4.2966 17.5263 4.52269 17.2333 4.8072L5.03837 16.4937L4.99056 16.725L4.14686 20.79L3.90625 21.875L5.03914 21.6444L9.28073 20.8358L9.52135 20.7893L21.7163 9.10279C22.014 8.82247 22.2504 8.48814 22.4118 8.11932C22.5731 7.7505 22.6562 7.35456 22.6562 6.95463C22.6562 6.55469 22.5731 6.15875 22.4118 5.78993C22.2504 5.42111 22.014 5.08678 21.7163 4.80646C21.4231 4.52199 21.0741 4.29599 20.6893 4.14148C20.3045 3.98697 19.8916 3.90702 19.4744 3.90625ZM19.4744 5.31495C19.8631 5.31495 20.2549 5.48495 20.6312 5.84636C21.3816 6.56476 21.3816 7.3445 20.6312 8.06363L20.0775 8.57138L17.7871 6.37703L18.3176 5.84636C18.6948 5.48495 19.0858 5.31495 19.4744 5.31495ZM16.7035 7.41693L18.9924 9.61128L9.66633 18.5484C9.16286 17.6043 8.36129 16.8366 7.37587 16.3547L16.7035 7.41693ZM6.38874 17.5565C6.84516 17.7325 7.25977 17.9951 7.60765 18.3284C7.95553 18.6618 8.22951 19.0592 8.41314 19.4966L5.88206 19.9815L6.38874 17.5565Z",
    fill: "#585C60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38874 17.5565C6.84516 17.7325 7.25977 17.9951 7.60765 18.3284C7.95553 18.6618 8.22951 19.0592 8.41314 19.4966L5.88206 19.9815L6.38874 17.5565Z",
    fill: "#585C60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4744 5.31495C19.8631 5.31495 20.2549 5.48495 20.6312 5.84636C21.3816 6.56476 21.3816 7.3445 20.6312 8.06363L20.0775 8.57138L17.7871 6.37703L18.3176 5.84636C18.6948 5.48495 19.0858 5.31495 19.4744 5.31495Z",
    fill: "#585C60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.59b046c5a1bf502f6d604a60bc7c3cb3.svg";
export { ForwardRef as ReactComponent };